import {
    CustomItemFormStructure,
    CustomItemRendererType,
    FormStructure,
} from '@europrocurement/flexy-form/components';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { jsonCustom, visibilityType } from '../types/formTypes';
import { checkFieldValue } from '../functions';

const jsonCustomToFormElement: (
    input: jsonCustom,
    customItemRenderer: CustomItemRendererType,
    visibility?: visibilityType,
) => FormStructure = (input, customItemRenderer, visibility) => {
    const baseField: CustomItemFormStructure = {
        type: 'customItem',
        name: input.name,
        renderField: (formContext, props) => customItemRenderer(formContext, props, visibility),
        inputlabel: input.inputlabel,
        placeholder: input.placeholder,
        rules: input.rules,
        visibility: input.visibility,
        tooltip: input.tooltip,
    };

    // comportement sur rules display
    if (input.rules && input.rules.display) {
        if (input.rules.display.fieldIsEqualTo) {
            const fieldNameToWatch = input.rules.display.fieldIsEqualTo.field;
            const valueToWatch = String(input.rules.display.fieldIsEqualTo.value);

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) => {
                const valueWatch: string = formContext.watch(fieldNameToWatch as string)?.value;

                return Array.isArray(valueToWatch)
                    ? valueToWatch.includes(valueWatch)
                    : valueWatch === valueToWatch;
            };
        }
        if (input.rules.display.isTrue) {
            const fieldNameToWatch = input.rules.display.isTrue;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
        if (input.rules.display.fieldIsChecked) {
            const fieldNameToWatch = input.rules.display.fieldIsChecked;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
        if (input.rules.display.fieldIsNotChecked) {
            const fieldNameToWatch = input.rules.display.fieldIsNotChecked;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, false, fieldNameToWatch);
        }
    }

    return baseField;
};

export default jsonCustomToFormElement;
